import SubCast from "../models/subcast";

export default class SubCastFactory {
  static createFromJson(json: any): SubCast {
    return new SubCast(json);
  }

  static createFromJsonArray(jsonArray: any[]): SubCast[] {
    const jsonData: SubCast[] = [];
    jsonArray.forEach((item) => {
      jsonData.push(SubCastFactory.createFromJson(item));
    });

    return jsonData;
  }
}
